import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, TranslationService } from '@spartacus/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../custom-landing.module';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-ships-consignment-details',
  standalone: true,
  imports: [CustomLandingModule, CommonModule, FormsModule, NgSelectModule, I18nModule, SharedModule, InfiniteScrollDirective],
  templateUrl: './ships-consignment-details.component.html',
  styleUrl: './ships-consignment-details.component.scss'
})
export class ShipsConsignmentDetailsComponent implements OnInit {
  title: any = '';
  enableLoader: boolean;
  navigationData: string = '';
  consignDetails: any = [];
  docdetails:any=[]
  id: any;
    passingArray: any = {};
  left = 0;
documents:any;
docuMents:any

  constructor(private toastrService: ToastrService, private route: ActivatedRoute,private http: HttpClient,
    private customProductService: CustomProfileService,private customProductsService: CustomProductsService,
    private translation: TranslationService, private router: Router,
   public cd: ChangeDetectorRef) {

  }
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.passingArray = {
      shipmentTab:  this.route.snapshot.queryParams.shipmentTab,
      searchText: this.id,
    }

    this.translation
      .translate('breadcrumb.shipconsigndetails.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
         this.translation
          .translate('breadcrumb.shipconsigndetails.breadcrumb')
          .subscribe(res => {
            this.navigationData = res;
          });
      this.getdetails();
  }
  backtoshipment() {
    this.router.navigate(['/shipment/shipconsignments'],{queryParams:{from:'details'},skipLocationChange: false });

  }
      donwloadReport(doc) {
      this.enableLoader = true;
      this.cd.detectChanges();
      this.left = window.outerWidth / 2;
      this.customProductsService.getSdocsString(doc.documentId, null, doc.nominationKey, doc.nominationKeyItem).subscribe(base64 => {
        if (base64.status == 'SUCCESS') {
            if (base64.downloadableUrl!=='NOT_FOUND') {//check whether url is there
            this.http.get(base64.downloadableUrl, { responseType: 'blob' }).subscribe((blob: Blob) => {
              const url = window.URL.createObjectURL(blob);//store the actual pdf in a browsers memory
              const ref = document.createElement("a");
              ref.href = url;
              ref.download = `${doc.documentName}.pdf`
              ref.click()
              window.URL.revokeObjectURL(url);//on click revoke the url and download it to system
              this.enableLoader = false;
              this.toastrService.show('Document downloaded successfully');
            });
            } else {
            this.enableLoader = false;
            this.toastrService.show('Document not available');
            }
        }
        else {
          this.enableLoader = false;
          this.toastrService.show('Download unsuccessful, please contact support team.');
        }
      })

  }

  getdetails() {
    let toastshown = false;
    this.enableLoader = true;
    this.customProductService.shipConsignDetails(this.passingArray).subscribe((data) => {
      this.enableLoader = false;
      this.consignDetails = data.consignmentsList;
      this.documents = this.consignDetails[0]?.shipmentDocuments || [];
      // Extract and deduplicate documents based on document id
      const uniqueDocuments = new Map();
      this.documents.forEach(doc => {
        if (!uniqueDocuments.has(doc.documentId)) {
          uniqueDocuments.set(doc.documentId, doc);
        }
      });
      this.docuMents = Array.from(uniqueDocuments.values());
          }, err => {
      // this.toastrService.show('Shipment list is having some error.')
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res => {
        if (!toastshown) {
          this.toastrService.show(res);
          toastshown = true
        }
      })
      this.enableLoader = false;
    })
  }
}
